module.exports = __webpack_public_path__ + "img/republick_of_artsakh.6a08f3e.webp";